import React, { useState } from "react";
//context
import { useData } from "../../../components/firebase/DataProvider";
//material
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import IconButton from "@material-ui/core/IconButton";
import LockIcon from "@material-ui/icons/Lock";
import PencairanDialog from "./pencairanDialog";
import {
  auth,
  firefunctions,
} from "../../../components/firebase/FirebaseProvider";

function DialogPw({ dialog: { open }, handleClose }) {
  const { phone, global_settings } = useData();

  const [submitting, setSubmitting] = useState(false);

  const [values, setValues] = useState({
    password: "",
    showPassword: false,
  });

  const [error, setError] = useState({
    password: "",
  });

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    // console.log(form)

    setError({
      ...error,
      [e.target.name]: "",
    });
  };

  const [dialog, setDialog] = useState(false);

  const validate = () => {
    const newError = { ...error };

    if (values.password.length < 8) {
      newError.password = "Password minimal 8 karakter";
    }
    if (!values.password) {
      newError.password = "Password  wajib diisi";
    }
    return newError;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const findErrors = await validate();

    if (Object.values(findErrors).some((message) => message !== "")) {
      setError(findErrors);
      setSubmitting(false);
    } else {
      // console.log(values.password);
      // console.log(phone.id);
      // console.log(error);
      try {
        const loginByPhoneAndPassword = firefunctions.httpsCallable(
          "loginByPhoneAndPassword"
        );

        const response = await loginByPhoneAndPassword({
          no_hp: phone?.id,
          password: values.password,
        });

        await auth.signInWithCustomToken(
          response?.data?.custom_token ?? "token"
        );

        setSubmitting(false);
        setDialog(true);
        handleClose();
        setValues({ password: "", showPassword: false });
      } catch (e) {
        setSubmitting(false);
        setError((error) => ({ ...error, password: e.message }));
        console.log(e.message);
      }
    }
  };

  // const handleSubmit = async () => {
  //   // console.log("lol");
  //   setSubmitting(true);
  // };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {global_settings?.disable_pencairan
            ? "Pemberitahuan"
            : "Masukan Password"}
        </DialogTitle>
        <DialogContent>
          {global_settings?.disable_pencairan ? (
            "Mohon Maaf, Saat ini Tokorame tidak menerima pengajuan pencairan kredit."
          ) : (
            <FormControl variant="outlined" fullWidth>
              <InputLabel htmlFor="outlined-adornment-password">
                Password
              </InputLabel>
              <form
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
              >
                <OutlinedInput
                  id="outlined-adornment-password"
                  label="Password"
                  disabled={submitting}
                  name="password"
                  type={values.showPassword ? "text" : "password"}
                  value={values.password}
                  autoFocus
                  onChange={handleChange}
                  startAdornment={
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  }
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  labelWidth={70}
                  placeholder="Password"
                />
              </form>
              {error.password ? (
                <FormHelperText error="true">{error.password}</FormHelperText>
              ) : null}
            </FormControl>
          )}
        </DialogContent>
        <DialogActions style={{ margin: "10px 15px" }}>
          <Button
            variant="outlined"
            disabled={submitting}
            size="small"
            fullWidth
            color="primary"
            onClick={handleClose}
          >
            {global_settings?.disable_pencairan ? "Kembali" : "Batal"}
          </Button>
          {global_settings?.disable_pencairan ? (
            ""
          ) : (
            <Button
              variant="contained"
              size="small"
              fullWidth
              color="primary"
              disabled={submitting}
              onClick={handleSubmit}
            >
              Kirim
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <PencairanDialog
        open={dialog}
        handleClose={() => {
          setDialog(false);
        }}
      />
    </>
  );
}

export default DialogPw;
